export default "__VITE_ASSET__ab9bfd09__"